/* eslint-disable react-hooks/exhaustive-deps */
import "./style.scss";
import Robo from "../../icons/robo.svg?react";
import TwoColumnDragDrop from "../Drag and Drop";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setAvailableMembers, setSelectedMembers } from "../../reducers/Audit";
import type { RootState } from "../../store";

interface DragItem {
  id: number | string;
  name: string;
  type?: string;
}

interface Props {
  userData: any;
  membersList: any[];
  auditMembers: any;
  auditData: any;
  handleChangeMembers: any;
  selectedMembersOption: any;
  setAuditData: any;
  destinationItems?: any;
  auditUpdatedata?: any;
  updateAuditeeInfo: any;
  validated: boolean;
  showAICompanion: boolean;
  onMembersChange?: (members: any[]) => void;
  setShowAICompanion?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Step3AuditorTeam: React.FC<Props> = ({
  userData,
  membersList,
  validated,
  showAICompanion,
  setShowAICompanion,
  updateAuditeeInfo,
  destinationItems,
  auditUpdatedata,
}) => {
  const dispatch = useDispatch();
  const available = useSelector(
    (state: RootState) => state.auditee.step1.availableMembers
  );
  const selected = useSelector(
    (state: RootState) => state.auditee.step1.selectedMembers
  );
  useEffect(() => {
    const hasAuditingId =
      auditUpdatedata?.auditingId !== null &&
      auditUpdatedata?.auditingId !== undefined;

    if (hasAuditingId) {
      const apiMembers = auditUpdatedata?.auditorMembers || [];

      // Transform API data into the expected shape
      const selectedFromAPI =
        apiMembers.map((member: any) => ({
          label: member.name?.trim(),
          value: member.id,
          email: member.email,
        })) || [];

      // Check for new members not yet in Redux
      const newSelected = selectedFromAPI.filter(
        (apiMember: any) =>
          !selected.some((sel: any) => sel.value === apiMember.value)
      );

      const updatedSelected = [...selected, ...newSelected];

      // Remove selected members from available list
      const availableItems = membersList.filter(
        (member: any) =>
          !updatedSelected.some((sel: any) => sel.value === member.value)
      );

      dispatch(setAvailableMembers(availableItems));
      dispatch(setSelectedMembers(updatedSelected));
      updateAuditeeInfo("members", updatedSelected);
    } else {
      const filteredAvailable = membersList.filter(
        (item: any) => !selected.some((sel: any) => sel.value === item.value)
      );
      dispatch(setAvailableMembers(filteredAvailable));
    }
  }, [auditUpdatedata, membersList]);

  const handleSelectionChange = (
    newSource: DragItem[],
    newDest: DragItem[]
  ) => {
    dispatch(setAvailableMembers(newSource));
    dispatch(setSelectedMembers(newDest));
    updateAuditeeInfo("members", newDest);
  };

  return (
    <div className="content-card">
      <div className="step-content">
        <div className="form-group">
          <div
            className={
              validated && !userData.auditor
                ? "readonly-field is-invalid borderRed"
                : "readonly-field"
            }
          >
            <strong>Auditor Team: Technology & Risk Management </strong>
          </div>
          <div className="align-AI">
            {!showAICompanion && (
              <div
                role="button"
                tabIndex={0}
                className="outer-circle"
                data-testid="robo-icon"
                style={{ margin: "94px 25px 0 0" }}
                onClick={() => setShowAICompanion?.(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setShowAICompanion?.(true);
                  }
                }}
              >
                <Robo className="ai-bot-button" />
              </div>
            )}
          </div>
        </div>

        <TwoColumnDragDrop
          totalData={membersList}
          totalcount={destinationItems}
          sourceItems={available}
          destinationItems={selected}
          onDragUpdate={handleSelectionChange}
          fieldMapping={{
            idKey: "value",
            nameKey: "label",
            typeKey: "email",
          }}
          layoutMode="grid"
          leftTitle="Team Members"
          rightTitle="Select Team Members Here"
          placeholderText="Drag team members from the left panel and drop them here"
        />
      </div>
    </div>
  );
};

export default Step3AuditorTeam;
